export default __webpack_public_path__ + "static/media/gallery_05.05509a5b.jpg";